import React from "react";
import styles from "./styles.module.scss";
import { WhatsappIcon, ClockIcon } from "../Icons";

const AjudaV2: React.FC = () => {
  return (
    <section className={styles.ajuda}>
      <div className={styles.box}>
        <div className={styles.head}>
          <h2>Precisa de ajuda?</h2>
          <p>
            Mande uma mensagem em um dos nosso canais de suporte direto e tenha
            sua questão resolvida por um especialista:
          </p>
        </div>

        <div className={styles.cards}>
          <a
            className={styles.card}
            href="https://wa.me/5531983019601"
            target="_blank"
            rel="noreferrer"
            title="Fale pelo WhatsApp"
          >
            <span className={styles.icon}>
              <WhatsappIcon />
            </span>
            <strong>Fale pelo WhatsApp</strong>
            <span className={styles.link}>(31) 98301-9601</span>
          </a>

          <a
            className={styles.card}
            href="https://www.whatsapp.com/channel/0029VaE5zJzGpLHJCrfUMY2U"
            target="_blank"
            rel="noreferrer"
            title="Participe do nosso canal"
          >
            <span className={styles.icon}>
              <img
                src="/images-capa2/global/logo-mark.svg"
                alt=""
                width={24}
                height={24}
                aria-hidden="true"
              />
            </span>
            <strong>Participe do nosso canal</strong>
            <span className={styles.link}>Parceiros Promo</span>
          </a>

          <div className={styles.card}>
            <span className={styles.icon}>
              <ClockIcon />
            </span>
            <strong>Horário de atendimento</strong>
            <span>
              De <b>segunda</b> a <b>sexta</b>: de 8h às 17h.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AjudaV2;
